(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~slider"],{

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./src/components/tooltip/index.jsx + 6 modules
var tooltip = __webpack_require__(34);

// CONCATENATED MODULE: ./src/components/slider/btn.jsx

/* harmony default export */ var btn = ({
  name: 'MegSliderBtn',
  components: {
    Tooltip: tooltip["default"]
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: false
    },
    tooltipClass: String
  },
  data: function data() {
    return {
      hovering: false,
      dragging: false,
      isClick: false,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: null,
      oldValue: this.value
    };
  },
  computed: {
    disabled: function disabled() {
      return this.$parent.sliderDisabled;
    },
    max: function max() {
      return this.$parent.max;
    },
    min: function min() {
      return this.$parent.min;
    },
    step: function step() {
      return this.$parent.step;
    },
    showTooltip: function showTooltip() {
      return this.$parent.showTooltip;
    },
    precision: function precision() {
      return this.$parent.precision;
    },
    currentPosition: function currentPosition() {
      return "".concat((this.value - this.min) / (this.max - this.min) * 100, "%");
    },
    enableFormat: function enableFormat() {
      return this.$parent.formatTooltip instanceof Function;
    },
    formatValue: function formatValue() {
      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
    },
    wrapperStyle: function wrapperStyle() {
      return this.vertical ? {
        bottom: this.currentPosition
      } : {
        left: this.currentPosition
      };
    }
  },
  watch: {
    dragging: function dragging(val) {
      this.$parent.dragging = val;
    }
  },
  methods: {
    handleMouseEnter: function handleMouseEnter() {
      if (this.disabled) return;
      this.hovering = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hovering = false;
    },
    onButtonDown: function onButtonDown(event) {
      if (this.disabled) return;
      this.$parent.onBlur();
      event.preventDefault();
      this.onDragStart(event);
      window.addEventListener('mousemove', this.onDragging);
      window.addEventListener('touchmove', this.onDragging);
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('touchend', this.onDragEnd);
      window.addEventListener('contextmenu', this.onDragEnd);
    },
    onLeftKeyDown: function onLeftKeyDown() {
      if (this.disabled) return;
      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
      this.$parent.emitChange();
    },
    onRightKeyDown: function onRightKeyDown() {
      if (this.disabled) return;
      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
      this.$parent.emitChange();
    },
    onDragStart: function onDragStart(event) {
      this.dragging = true;
      this.isClick = true;

      if (event.type === 'touchstart') {
        event.clientY = event.touches[0].clientY;
        event.clientX = event.touches[0].clientX;
      }

      if (this.vertical) {
        this.startY = event.clientY;
      } else {
        this.startX = event.clientX;
      }

      this.startPosition = parseFloat(this.currentPosition);
      this.newPosition = this.startPosition;
    },
    onDragging: function onDragging(event) {
      if (this.dragging) {
        this.isClick = false;
        this.$parent.resetSize();
        var diff = 0;

        if (event.type === 'touchmove') {
          event.clientY = event.touches[0].clientY;
          event.clientX = event.touches[0].clientX;
        }

        if (this.vertical) {
          this.currentY = event.clientY;
          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
        } else {
          this.currentX = event.clientX;
          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
        }

        this.newPosition = this.startPosition + diff;
        console.log(this.newPosition, 'newPostion');
        this.setPosition(this.newPosition);
      }
    },
    onDragEnd: function onDragEnd() {
      var _this = this;

      if (this.dragging) {
        /*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */
        setTimeout(function () {
          _this.dragging = false;

          if (!_this.isClick) {
            _this.setPosition(_this.newPosition);

            console.log('dragend:', _this.newPosition);

            _this.$parent.emitChange(); // debugger

          }
        }, 0);
        window.removeEventListener('mousemove', this.onDragging);
        window.removeEventListener('touchmove', this.onDragging);
        window.removeEventListener('mouseup', this.onDragEnd);
        window.removeEventListener('touchend', this.onDragEnd);
        window.removeEventListener('contextmenu', this.onDragEnd);
      }
    },
    setPosition: function setPosition(newPosition) {
      if (newPosition === null || isNaN(newPosition)) return;

      if (newPosition < 0) {
        newPosition = 0;
      } else if (newPosition > 100) {
        newPosition = 100;
      }

      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
      var steps = Math.round(newPosition / lengthPerStep);
      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      value = parseFloat(value.toFixed(this.precision));
      console.log('input:', value);
      this.$emit('input', value);

      if (!this.dragging && this.value !== this.oldValue) {
        this.oldValue = this.value;
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": "meg-slider__button-wrapper ".concat(this.vertical ? 'bar_vertical' : 'bar_align'),
      on: {
        "mouseenter": this.handleMouseEnter,
        "mouseleave": this.handleMouseLeave,
        "mousedown": this.onButtonDown,
        "touchstart": this.onButtonDown,
        "focus": this.handleMouseEnter,
        "blur": this.handleMouseLeave
      },
      style: this.wrapperStyle,
      ref: "button",
      attrs: {
        tabIndex: 0
      }
    }, [h("meg-tooltip", {
      ref: "tooltip",
      attrs: {
        disabled: !this.showTooltip,
        popperClass: this.tooltipClass,
        placement: this.vertical ? 'right' : 'top'
      }
    }, [h("span", {
      slot: 'title'
    }, [this.formatValue]), h("div", {
      "class": "slider-btn \n                        ".concat(this.dragging ? 'dragging' : '', "  \n                        ").concat(this.disabled ? 'slider-btn__disabled' : '', " \n                        ").concat(this.hovering ? 'slider-btn__hover' : '', "\n                        ")
    })])]);
  }
});
// CONCATENATED MODULE: ./src/components/slider/mark.jsx
/* harmony default export */ var mark = ({
  name: 'MegSliderMarker',
  props: {
    mark: {
      type: [String, Object]
    }
  },
  render: function render() {
    var h = arguments[0];
    var label = typeof this.mark === 'string' ? this.mark : this.mark.label;
    return h("div", {
      "class": "meg-slider__marks-text",
      style: this.mark.style || {}
    }, [label]);
  }
});
// CONCATENATED MODULE: ./src/components/slider/main.jsx





/* harmony default export */ var main = ({
  name: 'MegSlider',
  components: {
    SliderBtn: btn,
    SliderMarker: mark
  },
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: [Number, Array],
      default: 0
    },
    showInput: {
      type: Boolean,
      default: false
    },
    showInputControls: {
      type: Boolean,
      default: true
    },
    inputSize: {
      type: String,
      default: 'default'
    },
    showStops: {
      type: Boolean,
      default: false
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    formatTooltip: Function,
    disabled: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    height: {
      type: String
    },
    debounce: {
      type: Number,
      default: 300
    },
    label: {
      type: String
    },
    tooltipClass: String,
    marks: Object
  },
  data: function data() {
    return {
      firstValue: null,
      secondValue: null,
      oldValue: null,
      dragging: false,
      sliderSize: 1
    };
  },
  watch: {
    value: function value(val, oldVal) {
      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
        return item === oldVal[index];
      })) {
        return;
      }

      this.setValues();
    },
    dragging: function dragging(val) {
      if (!val) {
        this.setValues();
      }
    },
    firstValue: function firstValue(val) {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      } else {
        if (this.val && this.val < this.minValue) {
          this.$emit('input', this.minValue);
          return;
        }

        if (this.val && this.val > this.maxValue) {
          this.$emit('input', this.maxValue);
          return;
        }

        if (!this.val || typeof this.val !== 'number') {
          this.$emit('input', val);
          return;
        }

        this.$emit('input', val);
      }
    },
    secondValue: function secondValue() {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      }
    },
    min: function min() {
      this.setValues();
    },
    max: function max() {
      this.setValues();
    }
  },
  computed: {
    stops: function stops() {
      var _this = this;

      if (!this.showStops || this.min > this.max) return [];

      if (this.step === 0) {
         false && false;
        return [];
      }

      var stopCount = (this.max - this.min) / this.step;
      var stepWidth = 100 * this.step / (this.max - this.min);
      var result = [];

      for (var i = 1; i < stopCount; i++) {
        result.push(i * stepWidth);
      }

      if (this.range) {
        return result.filter(function (step) {
          return step < 100 * (_this.minValue - _this.min) / (_this.max - _this.min) || step > 100 * (_this.maxValue - _this.min) / (_this.max - _this.min);
        });
      } else {
        return result.filter(function (step) {
          return step > 100 * (_this.firstValue - _this.min) / (_this.max - _this.min);
        });
      }
    },
    markList: function markList() {
      var _this2 = this;

      if (!this.marks) {
        return [];
      }

      var marksKeys = Object.keys(this.marks);
      return marksKeys.map(parseFloat).sort(function (a, b) {
        return a - b;
      }).filter(function (point) {
        return point <= _this2.max && point >= _this2.min;
      }).map(function (point) {
        return {
          point: point,
          position: (point - _this2.min) * 100 / (_this2.max - _this2.min),
          mark: _this2.marks[point]
        };
      });
    },
    minValue: function minValue() {
      return Math.min(this.firstValue, this.secondValue);
    },
    maxValue: function maxValue() {
      return Math.max(this.firstValue, this.secondValue);
    },
    barSize: function barSize() {
      return this.range ? "".concat(100 * (this.maxValue - this.minValue) / (this.max - this.min), "%") : "".concat(100 * (this.firstValue - this.min) / (this.max - this.min), "%");
    },
    barStart: function barStart() {
      return this.range ? "".concat(100 * (this.minValue - this.min) / (this.max - this.min), "%") : '0%';
    },
    precision: function precision() {
      var precisions = [this.min, this.max, this.step].map(function (item) {
        var decimal = ('' + item).split('.')[1];
        return decimal ? decimal.length : 0;
      });
      return Math.max.apply(null, precisions);
    },
    runwayStyle: function runwayStyle() {
      return this.vertical ? {
        height: this.height
      } : {};
    },
    barStyle: function barStyle() {
      return this.vertical ? {
        height: this.barSize,
        bottom: this.barStart,
        width: '6px'
      } : {
        width: this.barSize,
        left: this.barStart,
        height: '6px'
      };
    },
    sliderDisabled: function sliderDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  mounted: function mounted() {
    var valuetext;

    if (this.range) {
      if (Array.isArray(this.value)) {
        this.firstValue = Math.max(this.min, this.value[0]);
        this.secondValue = Math.min(this.max, this.value[1]);
      } else {
        this.firstValue = this.min;
        this.secondValue = this.max;
      }

      this.oldValue = [this.firstValue, this.secondValue];
      valuetext = "".concat(this.firstValue, "-").concat(this.secondValue);
    } else {
      if (typeof this.value !== 'number' || isNaN(this.value)) {
        this.firstValue = this.min;
      } else {
        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
      }

      this.oldValue = this.firstValue;
      valuetext = this.firstValue;
    }

    this.$el.setAttribute('aria-valuetext', valuetext); // label screen reader

    this.$el.setAttribute('aria-label', this.label ? this.label : "slider between ".concat(this.min, " and ").concat(this.max));
    this.resetSize();
    window.addEventListener('resize', this.resetSize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resetSize);
  },
  methods: {
    valueChanged: function valueChanged() {
      var _this3 = this;

      if (this.range) {
        return ![this.minValue, this.maxValue].every(function (item, index) {
          return item === _this3.oldValue[index];
        });
      } else {
        return this.value !== this.oldValue;
      }
    },
    setValues: function setValues() {
      if (this.min > this.max) {
        console.error('[Element Error][Slider]min should not be greater than max.');
        return;
      }

      var val = this.value;

      if (this.range && Array.isArray(val)) {
        if (val[1] < this.min) {
          this.$emit('input', [this.min, this.min]);
        } else if (val[0] > this.max) {
          this.$emit('input', [this.max, this.max]);
        } else if (val[0] < this.min) {
          this.$emit('input', [this.min, val[1]]);
        } else if (val[1] > this.max) {
          this.$emit('input', [val[0], this.max]);
        } else {
          this.firstValue = val[0];
          this.secondValue = val[1];

          if (this.valueChanged()) {
            // this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
            this.oldValue = val.slice();
          }
        }
      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
        if (val < this.min) {
          this.$emit('input', this.min);
        } else if (val > this.max) {
          this.$emit('input', this.max);
        } else {
          this.firstValue = val;

          if (this.valueChanged()) {
            // this.dispatch('ElFormItem', 'el.form.change', val);
            this.oldValue = val;
          }
        }
      } else if (!this.range && typeof val !== 'number') {
        this.firstValue = this.min;
        this.$emit('input', this.min);
      }
    },
    setPosition: function setPosition(percent) {
      var targetValue = this.min + percent * (this.max - this.min) / 100;

      if (!this.range) {
        this.$refs.button1.setPosition(percent);
        return;
      }

      var button;

      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
      } else {
        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
      }

      this.$refs[button].setPosition(percent);
    },
    resetSize: function resetSize() {
      if (this.$refs.slider) {
        if (this.vertical) {
          this.sliderSize = this.$refs.slider.clientHeight;
        } else {
          this.sliderSize = this.$refs.slider.clientWidth;
        }
      }
    },
    onSliderClick: function onSliderClick(event) {
      if (this.sliderDisabled || this.dragging) return;
      this.resetSize();

      if (this.vertical) {
        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100);
      } else {
        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100);
      }

      this.emitChange();
    },
    emitChange: function emitChange() {
      var _this4 = this;

      this.$nextTick(function () {
        if (_this4.range && _this4.minValue < _this4.min) {
          _this4.minValue = _this4.min;
        }

        if (_this4.range && _this4.maxValue > _this4.max) {
          _this4.maxValue = _this4.max;
        }

        if (!_this4.range && _this4.value > _this4.max) {
          _this4.value = _this4.max;
        }

        if (!_this4.range && _this4.value < _this4.min) {
          _this4.value = _this4.min;
        }

        _this4.$emit('change', _this4.range ? [_this4.minValue, _this4.maxValue] : _this4.value);
      });
    },
    getStopStyle: function getStopStyle(position) {
      return this.vertical ? {
        'bottom': position + '%'
      } : {
        'left': position + '%'
      };
    },
    onBlur: function onBlur() {
      this.$refs.input && this.$refs.input.blur();
    }
  },
  render: function render() {
    var _this5 = this;

    var h = arguments[0];
    return h("div", {
      "class": "meg-slider ".concat(this.vertical ? 'is_vertical' : 'no_vertical', " ").concat(this.showInput ? 'meg-slider--with-input' : ''),
      attrs: {
        role: "slider",
        "aria-valuemin": this.min,
        "aria-valuemax": this.max,
        "aria-orientation": this.vertical ? 'vertical' : 'horizontal',
        "aria-disabled": this.sliderDisabled
      },
      on: {
        "mouseenter": function mouseenter() {
          if (!_this5.disabled) {
            _this5.$refs.slider.style.background = '#DEDEE0';
          }
        },
        "mouseleave": function mouseleave() {
          _this5.$refs.slider.style.background = '#EDEDED';
        }
      }
    }, [this.showInput && !this.range && h("meg-input-number", babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        value: _this5.firstValue
      },
      on: {
        "input": function input($$v) {
          _this5.firstValue = $$v;
        }
      }
    }, {
      directives: [{
        name: "model",
        value: _this5.firstValue
      }]
    }, {
      "class": "meg-slider__input",
      ref: "input",
      on: {
        "change": this.emitChange
      },
      attrs: {
        step: this.step,
        disabled: this.sliderDisabled,
        controls: this.showInputControls,
        min: this.min,
        max: this.max,
        debounce: this.debounce,
        size: this.inputSize
      }
    }])), h("div", {
      "class": "meg-slider__runway ".concat(this.showInput ? 'show-input' : '', " ").concat(this.disabled ? 'disabled' : ''),
      on: {
        "click": this.onSliderClick
      },
      ref: "slider",
      style: this.runwayStyle
    }, [h("div", {
      "class": "meg-slider__bar ".concat(this.disabled ? 'bar-disabled' : ''),
      style: this.barStyle
    }), h(btn, babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        value: _this5.firstValue
      },
      on: {
        "input": function input($$v) {
          _this5.firstValue = $$v;
        }
      }
    }, {
      directives: [{
        name: "model",
        value: _this5.firstValue
      }]
    }, {
      attrs: {
        vertical: this.vertical,
        tooltipClass: this.tooltipClass
      },
      ref: "button1"
    }])), this.range && h(btn, babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        vertical: this.vertical,
        value: _this5.secondValue
      },
      on: {
        "input": function input($$v) {
          _this5.secondValue = $$v;
        }
      }
    }, {
      directives: [{
        name: "model",
        value: _this5.secondValue
      }]
    }, {
      attrs: {
        tooltipClass: this.tooltipClass
      },
      ref: "button2"
    }])), this.showStops && this.stops.map(function (item, index) {
      return h("div", {
        "class": "meg-slider__stop",
        key: index,
        style: _this5.getStopStyle(item)
      });
    }), this.markList.length > 0 && h("template", [h("div", [this.markList.map(function (item, index) {
      return h("div", {
        style: _this5.getStopStyle(item.position),
        "class": "meg-slider__stop meg-slider__marks-stop",
        key: index
      });
    })]), h("div", {
      "class": "meg-slider__marks"
    }, [this.markList.map(function (item, index) {
      return h(mark, {
        attrs: {
          mark: item.mark
        },
        key: index,
        style: _this5.getStopStyle(item.position)
      });
    })])])])]);
  }
});
// CONCATENATED MODULE: ./src/components/slider/index.jsx
// 样式文件
// import './style/index.scss';


main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var slider = __webpack_exports__["default"] = (main);

/***/ })

}]);